import { createSlice } from "@reduxjs/toolkit";

export type AuthSliceState = {
  userData: {
    Username: string | null;
    Password: string;
  };
  isLoggedIn: boolean;
  token: string;
  response: boolean;
  errorMessage: string;
};

function InitAuthSlice(): AuthSliceState {
  const userName = localStorage.getItem("userName");
  const loginValue: string | null = localStorage.getItem("isLoggedIn");

  return {
    userData: {
      Username: userName,
      Password: "",
    },
    isLoggedIn: JSON.parse(loginValue as string),
    token: "",
    response: false,
    errorMessage: "",
  };
}

const authSlice = createSlice({
  name: "authSlice",
  initialState: InitAuthSlice(),
  reducers: {
    login: (state: AuthSliceState, data) => {
      const { userData, response, token } = data.payload;

      state.userData = userData;
      state.token = token;
      state.response = response;

      if (state.response) {
        localStorage.setItem("token", state.token);
        state.isLoggedIn = true;
        localStorage.setItem("userName", userData.Username);
        localStorage.setItem("isLoggedIn", "true");
      }
    },

    logout: (state: AuthSliceState) => {
      localStorage.clear();
      state.isLoggedIn = false;
    },
  },
});

export const AuthReducer = authSlice.reducer;
export const AuthActions = authSlice.actions;
